<div class="pagination-container">
  @for (page of paginationService.pages(); track page; let i = $index) {
    <button
          class="govuk-button pagination-button {{ paginationService.isShown(i)? '' : 'govuk-visually-hidden' }} {{ i === paginationService.selectedPage ? 'pagination-button--active' : 'govuk-button--secondary' }}
          data-module="govuk-button
          [routerLink]="[paginationService.routerLink]"
      [queryParams]="{ start: paginationService.size*i, size: paginationService.size, active: paginationService.active }"
    [innerHTML]="paginationService.buttonText(i)"></button>
  }
</div>
